const BaseWorker = window.Worker;

class Worker extends BaseWorker {
  constructor(scriptURL, options) {
    const url = String(scriptURL);
    const sameOrigin = new URL(import.meta.url).origin === location.origin;

    super(
      !sameOrigin && url.includes('://') && !url.startsWith(location.origin)
        ? // Launch the worker with an inline script that will use `importScripts`
          // to bootstrap the actual script to work around the same origin policy.
          URL.createObjectURL(
            new Blob(
              [
                `importScripts=((i)=>(...a)=>i(...a.map((u)=>''+new URL(u,"${url}"))))(importScripts);importScripts("${url}")`,
              ],
              { type: 'application/javascript' }
            )
          )
        : scriptURL,
      options
    );
  }
}

export { Worker };
